import React from 'react';
import { LogoSmall } from '@/resources/assets/images';
import NewSequenceContainer from '../components/sequenceStartPage/NewSequenceContainer';
import NewSequenceFooter from '../components/NewSequenceFooter';
import { useSequencesContext } from '../SequencesContext';
import SequencesStepsList from '../components/StepsList';
import type { TemplatesType } from '../hooks/useTemplates';

export default function SequenceStartPage() {
	const { selectedTemplate } = useSequencesContext();

	return (
		<>
			<div className="flex h-full w-full pb-16">
				<div className="w-2/5">
					<NewSequenceContainer />
				</div>
				<div className="w-3/5 overflow-hidden rounded-xl border border-dark-grey bg-dm-black">
					{selectedTemplate ? (
						<NewSequenceSteps selectedTemplate={selectedTemplate} />
					) : (
						<NewSequenceTooltipContainer />
					)}
				</div>
			</div>
			<NewSequenceFooter />
		</>
	);
}

function NewSequenceSteps({
	selectedTemplate
}: {
	selectedTemplate: TemplatesType;
}) {
	return (
		<div className="h-full bg-dm-black3">
			<SequencesStepsList steps={selectedTemplate.steps} />
		</div>
	);
}

function NewSequenceTooltipContainer() {
	return (
		<div className="flex h-full flex-col p-10">
			<div className="mb-6 flex items-center gap-3 rounded-xl bg-dm-black3 p-8">
				<LogoSmall />
				<h6 className="text-xl font-bold text-gray-200">
					Would you like to select a sequence template?
				</h6>
			</div>
			<div className="h-full rounded-xl bg-dm-black3 p-8">
				<p className="text-xl text-gray-200">
					Embrace the flexibility to create your sequence from
					scratch, tailoring each element to resonate with your unique
					audience.
					<br />
					<br />
					Alternatively, opt for one of our expertly crafted pre-made
					templates for a fast and efficient setup, ensuring a smooth
					start to your sequence.
					<br />
					<br /> Whichever path you choose, you're empowered to engage
					your audience in a manner that aligns perfectly with your
					specific goals and style.
				</p>
			</div>
		</div>
	);
}
